import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../../supabaseClient'
import { Lock, CheckCircle2 } from 'lucide-react'

const inputCls = "w-full bg-gray-900 border border-gray-800 rounded-lg px-4 py-3 text-white placeholder-gray-600 focus:outline-none focus:border-violet-500 transition-colors text-sm"

const ResetPassword = () => {
  const navigate = useNavigate()
  const [ready, setReady] = useState(false)       // sessione di recupero valida
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [done, setDone] = useState(false)

  // Quando si arriva dal link email, Supabase emette l'evento PASSWORD_RECOVERY
  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'PASSWORD_RECOVERY' || session) setReady(true)
    })
    // Fallback: se la sessione è già attiva
    supabase.auth.getSession().then(({ data }) => { if (data.session) setReady(true) })
    return () => subscription.unsubscribe()
  }, [])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError(null)
    if (newPassword.length < 8) { setError('La password deve avere almeno 8 caratteri.'); return }
    if (newPassword !== confirmPassword) { setError('Le due password non coincidono.'); return }
    setLoading(true)
    const { error: e2 } = await supabase.auth.updateUser({ password: newPassword })
    if (e2) {
      setError(e2.message.includes('should be different') ? 'La nuova password deve essere diversa dalla precedente.' : e2.message)
      setLoading(false)
      return
    }
    setDone(true)
    setLoading(false)
    setTimeout(() => navigate('/', { replace: true }), 2000)
  }

  return (
    <div className="min-h-screen bg-gray-950 flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <img src="/PLUTONIC_LOGO_WHITE_NOBG.png" alt="Plutonic Studio"
            className="h-12 w-auto object-contain mx-auto mb-3" />
          <p className="text-gray-500 text-sm">Reimposta password</p>
        </div>

        {done ? (
          <div className="text-center py-6">
            <div className="w-14 h-14 bg-emerald-500/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <CheckCircle2 size={26} className="text-emerald-400" />
            </div>
            <h2 className="text-white font-semibold mb-1">Password aggiornata!</h2>
            <p className="text-gray-500 text-sm">Ti stiamo reindirizzando...</p>
          </div>
        ) : !ready ? (
          <div className="text-center py-8">
            <div className="w-6 h-6 border-2 border-violet-500 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
            <p className="text-gray-500 text-sm">Verifica del link in corso...</p>
            <p className="text-gray-600 text-xs mt-2">Se non succede nulla, richiedi un nuovo link dalla pagina di login.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm text-gray-400 mb-1">Nuova password</label>
              <input type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)}
                required placeholder="Almeno 8 caratteri" autoComplete="new-password" className={inputCls} />
            </div>
            <div>
              <label className="block text-sm text-gray-400 mb-1">Conferma password</label>
              <input type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)}
                required placeholder="Ripeti la password" autoComplete="new-password" className={inputCls} />
            </div>
            {error && <p className="text-red-400 text-sm text-center">{error}</p>}
            <button type="submit" disabled={loading}
              className="w-full flex items-center justify-center gap-2 bg-violet-600 hover:bg-violet-500 disabled:opacity-50 text-white font-semibold py-3 rounded-lg transition-colors">
              <Lock size={15} />
              {loading ? 'Aggiornamento...' : 'Imposta nuova password'}
            </button>
          </form>
        )}
      </div>
    </div>
  )
}

export default ResetPassword
